var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: {
          "container-class": "tag-badge-main-info my-4",
          content: "I. Completar Cita",
          icon: "fas fa-clipboard-list-check"
        }
      }),
      _c("validation-observer", { ref: "form", attrs: { novalidate: "" } }, [
        _c("div", { staticClass: "bg-secondary-11 p-4 rounded my-3" }, [
          _c("div", { staticClass: "data-name" }, [
            _vm._v(
              " ¿La cita fue completada en el mismo municipio, localización, especialista, día y hora? "
            )
          ]),
          _c(
            "div",
            [
              !_vm.isReadOnly
                ? _c("validation-provider", {
                    ref: "isCompletedOtherLocation",
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-radio", {
                                staticClass: "mt-1 ml-n3",
                                attrs: {
                                  "custom-error-msg":
                                    "Favor contestar Sí o No.",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  "is-inline": "",
                                  name: "isCompletedOtherLocation",
                                  options: _vm.yesNoOptions
                                },
                                on: {
                                  input: _vm.onChangeIsCompletedOtherLocation
                                },
                                model: {
                                  value: _vm.model.isCompletedOtherLocation,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.model,
                                      "isCompletedOtherLocation",
                                      $$v
                                    )
                                  },
                                  expression: "model.isCompletedOtherLocation"
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1653959511
                    )
                  })
                : _c("div", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("boolText")(_vm.model.isCompletedOtherLocation)
                        ) +
                        " "
                    )
                  ])
            ],
            1
          ),
          _c("div", { staticClass: "row my-3" }, [
            _c("div", { staticClass: "col-md-4 border-right" }, [
              _c("div", [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v(" Proveedor ")
                ]),
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.model.companyName)) + " "
                  )
                ])
              ]),
              _c("div", { staticClass: "my-3" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v(" Dirección: ")
                ]),
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.locationAddress)) + " "
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "col-md px-5" }, [
              _c(
                "div",
                [
                  _c("div", { staticClass: "data-name" }, [_vm._v(" Fecha: ")]),
                  _vm.model.isCompletedOtherLocation == false && !_vm.isReadOnly
                    ? _c("validation-provider", {
                        ref: "appointmentDate",
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      "max-date": new Date(),
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    model: {
                                      value: _vm.model.appointmentDate,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "appointmentDate",
                                          $$v
                                        )
                                      },
                                      expression: "model.appointmentDate"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1908681927
                        )
                      })
                    : _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("date")(_vm.model.appointmentDate)) +
                            " "
                        )
                      ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "my-3" },
                [
                  _c("div", { staticClass: "data-name" }, [
                    _vm._v(" Municipio: ")
                  ]),
                  _vm.model.isCompletedOtherLocation == false && !_vm.isReadOnly
                    ? _c("validation-provider", {
                        ref: "municipality",
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      options: _vm.catalog.municipalities,
                                      placeholder: "Seleccione"
                                    },
                                    on: { input: _vm.onChangeMunicipality },
                                    model: {
                                      value: _vm.model.municipality,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "municipality", $$v)
                                      },
                                      expression: "model.municipality"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1150460431
                        )
                      })
                    : _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("empty")(
                                _vm.model.locationAddressMunicipalityName
                              )
                            ) +
                            " "
                        )
                      ])
                ],
                1
              ),
              _c("div", { staticClass: "row my-4" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-6" },
                  [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v(" Localización: ")
                    ]),
                    _vm.model.isCompletedOtherLocation == false &&
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          ref: "location",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.catalog.locations,
                                        placeholder: "Seleccione"
                                      },
                                      on: { input: _vm.onChangeLocation },
                                      model: {
                                        value: _vm.model.location,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "location", $$v)
                                        },
                                        expression: "model.location"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1699517803
                          )
                        })
                      : _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.model.locationTypeName) +
                              " - " +
                              _vm._s(_vm.model.locationName) +
                              " "
                          )
                        ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-1 col-md-6" },
                  [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v(" Especialista: ")
                    ]),
                    _vm.model.isCompletedOtherLocation == false &&
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          ref: "specialist",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.catalog.specialists,
                                        placeholder: "Seleccione"
                                      },
                                      on: { input: _vm.onChangeSpecialist },
                                      model: {
                                        value: _vm.model.specialist,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "specialist", $$v)
                                        },
                                        expression: "model.specialist"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1046878969
                          )
                        })
                      : _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(_vm.model.specialistFullname)
                              ) +
                              " "
                          )
                        ])
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "row my-4" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-md-4" },
                  [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v(" Hora Desde: ")
                    ]),
                    _vm.model.isCompletedOtherLocation == false &&
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          ref: "timeStart",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-time-picker", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        error: errors[0]
                                      },
                                      on: { input: _vm.onChangeTimeStart },
                                      model: {
                                        value: _vm.model.timeStart,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "timeStart", $$v)
                                        },
                                        expression: "model.timeStart"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            73666315
                          )
                        })
                      : _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("hour")(_vm.model.timeStart)) +
                              " "
                          )
                        ])
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-12 col-md",
                    class: {
                      "pt-1": _vm.model.isCompletedOtherLocation === false
                    }
                  },
                  [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v(" Hora Hasta: ")
                    ]),
                    _vm.model.isCompletedOtherLocation == false &&
                    !_vm.isReadOnly
                      ? _c("validation-provider", {
                          ref: "timeEnd",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-time-picker", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        error: errors[0]
                                      },
                                      model: {
                                        value: _vm.model.timeEnd,
                                        callback: function($$v) {
                                          _vm.$set(_vm.model, "timeEnd", $$v)
                                        },
                                        expression: "model.timeEnd"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            3995278859
                          )
                        })
                      : _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("hour")(_vm.model.timeEnd)) +
                              " "
                          )
                        ]),
                    _vm.validations.invalidDate
                      ? _c("error", {
                          attrs: {
                            message: _vm.validations.invalidDate,
                            variant: "no-border mt-1"
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ])
            ])
          ])
        ]),
        _c(
          "div",
          { staticClass: "mt-3" },
          [
            _vm.model.hasSignLanguageInterpreterInContract
              ? _c("validation-provider", {
                  ref: "hasSignLanguageInterpreter",
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-radio", {
                              staticClass: "mt-4 mb-2",
                              attrs: {
                                "custom-error-msg": "El campo es requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                "is-inline": "",
                                label:
                                  "¿La evaluación tuvo asistencia de intérprete de lenguaje de señas?",
                                name: "hasSignLanguageInterpreter",
                                options: _vm.yesNoOptions
                              },
                              model: {
                                value: _vm.model.hasSignLanguageInterpreter,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "hasSignLanguageInterpreter",
                                    $$v
                                  )
                                },
                                expression: "model.hasSignLanguageInterpreter"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1665697152
                  )
                })
              : _vm._e(),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-8" },
                [
                  _c("div", { staticClass: "data-name" }, [
                    _vm._v(
                      " ¿La evaluación fue realizada por un Interno/Practicante? "
                    )
                  ]),
                  !_vm.isReadOnly
                    ? _c("validation-provider", {
                        ref: "appointmentHasPractitioner",
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-radio", {
                                    staticClass: "mt-4 mb-2",
                                    attrs: {
                                      "custom-error-msg":
                                        "Favor contestar Sí o No.",
                                      disabled: _vm.isReadOnly,
                                      error: errors[0],
                                      "is-inline": "",
                                      name: "appointmentHasPractitioner",
                                      options: _vm.yesNoOptions
                                    },
                                    on: { input: _vm.onChangePractitioner },
                                    model: {
                                      value:
                                        _vm.model.appointmentHasPractitioner,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "appointmentHasPractitioner",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "model.appointmentHasPractitioner"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          504240139
                        )
                      })
                    : _c("div", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("boolText")(
                                _vm.model.appointmentHasPractitioner
                              )
                            ) +
                            " "
                        )
                      ])
                ],
                1
              )
            ]),
            _vm.model.appointmentHasPractitioner
              ? _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v(" Interno/Practicante: ")
                    ]),
                    _vm.catalog.practitioners.length > 0
                      ? _c("validation-provider", {
                          ref: "practitioner",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        options: _vm.catalog.practitioners,
                                        placeholder: "seleccione"
                                      },
                                      model: {
                                        value: _vm.model.practitioner,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "practitioner",
                                            $$v
                                          )
                                        },
                                        expression: "model.practitioner"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2318397590
                          )
                        })
                      : _c("error", {
                          attrs: {
                            message:
                              "El Especialista seleccionado no tiene relacionado Practicante/Interno a su licencia y Lugar de Servicio. (R80556)"
                          }
                        })
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              [
                _vm.showHasEducationalEvaluation
                  ? _c("validation-provider", {
                      ref: "hasEducationalEvaluation",
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-radio", {
                                  staticClass: "mt-4 mb-2",
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor contestar Sí o No.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    "is-inline": "",
                                    label:
                                      "¿La evaluación realizada fue Educativa?",
                                    name: "hasEducationalEvaluation",
                                    options: _vm.yesNoOptions
                                  },
                                  model: {
                                    value: _vm.model.hasEducationalEvaluation,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "hasEducationalEvaluation",
                                        $$v
                                      )
                                    },
                                    expression: "model.hasEducationalEvaluation"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1990112032
                      )
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v(
                    " Requiere reevaluación a partir de la implementación de las recomendaciones ofrecidas en este informe de evaluación. "
                  )
                ]),
                !_vm.isReadOnly
                  ? _c("validation-provider", {
                      ref: "hasRecommendedReevaluation",
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-radio", {
                                  staticClass: "mt-4 mb-2",
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor contestar Sí o No.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    "is-inline": "",
                                    name: "hasRecommendedReevaluation",
                                    options: _vm.yesNoOptions
                                  },
                                  on: {
                                    input:
                                      _vm.onChangeHasRecommendedReevaluation
                                  },
                                  model: {
                                    value: _vm.model.hasRecommendedReevaluation,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.model,
                                        "hasRecommendedReevaluation",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "model.hasRecommendedReevaluation"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        3234206643
                      )
                    })
                  : _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("boolText")(
                              _vm.model.hasRecommendedReevaluation
                            )
                          ) +
                          " "
                      )
                    ])
              ],
              1
            ),
            _vm.model.hasRecommendedReevaluation
              ? _c("div", { staticClass: "bg-secondary-11 p-3 rounded mt-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-lg-3 col-md-3" },
                      [
                        _c("validation-provider", {
                          ref: "reevaluationTime",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-drop-down", {
                                      attrs: {
                                        clearable: !_vm.isReadOnly,
                                        "custom-error-msg":
                                          "El campo es es requerido.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        fieldkey: "id",
                                        fieldname: "name",
                                        label: "Tiempo para reevaluación:",
                                        options: _vm.catalog.reevaluationTimes,
                                        placeholder: "Seleccione"
                                      },
                                      on: {
                                        input: _vm.onChangeReevaluationTime
                                      },
                                      model: {
                                        value: _vm.model.reevaluationTime,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "reevaluationTime",
                                            $$v
                                          )
                                        },
                                        expression: "model.reevaluationTime"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            816885630
                          )
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-12 pt-2" },
                      [
                        _c("validation-provider", {
                          ref: "recommendedReevaluationComment",
                          attrs: { rules: "required" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function({ errors }) {
                                  return [
                                    _c("custom-text-area", {
                                      attrs: {
                                        "custom-error-msg":
                                          "El campo es requerido.",
                                        disabled: _vm.isReadOnly,
                                        error: errors[0],
                                        label: "¿Con qué finalidad?",
                                        maxlength: 3000,
                                        "show-char-count": ""
                                      },
                                      model: {
                                        value:
                                          _vm.model
                                            .recommendedReevaluationComment,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.model,
                                            "recommendedReevaluationComment",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "model.recommendedReevaluationComment"
                                      }
                                    })
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2280732541
                          )
                        })
                      ],
                      1
                    )
                  ])
                ])
              : _vm._e(),
            _c(
              "div",
              { class: _vm.isReadOnly ? "mt-3" : "" },
              [
                _c("validation-provider", {
                  ref: "statusComment",
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function({ errors }) {
                        return [
                          !_vm.isReadOnly
                            ? _c("custom-text-area", {
                                staticClass: "mt-4 mb-2",
                                attrs: {
                                  "custom-error-msg": "El campo es requerido.",
                                  disabled: _vm.isReadOnly,
                                  error: errors[0],
                                  label: "Impresión Diagnóstica:",
                                  maxlength: 2000
                                },
                                model: {
                                  value: _vm.model.statusComment,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "statusComment", $$v)
                                  },
                                  expression: "model.statusComment"
                                }
                              })
                            : _c("div", { staticClass: "d-flex flex-column" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "text-muted",
                                    staticStyle: { "font-size": "14px" }
                                  },
                                  [_vm._v(" Impresión Diagnóstica: ")]
                                ),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.model.statusComment))
                                ])
                              ])
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm.canAddDiagnosisInPilot
              ? _c(
                  "div",
                  { staticClass: "my-3" },
                  [
                    _c("custom-todo", {
                      attrs: {
                        draggable: !_vm.isReadOnly,
                        "has-chip": "",
                        "has-pagination": "",
                        "is-drop-down": "",
                        "is-read-only": _vm.isReadOnly,
                        label: "¿Cuál es el diagnóstico del estudiante?",
                        options: _vm.diagnosticsOptions,
                        separator: "Diagnósticos añadidos"
                      },
                      model: {
                        value: _vm.model.diagnostics,
                        callback: function($$v) {
                          _vm.$set(_vm.model, "diagnostics", $$v)
                        },
                        expression: "model.diagnostics"
                      }
                    }),
                    _c("validation-provider", {
                      attrs: {
                        name: "diagnostics",
                        rules: _vm.model.hasCpt ? "required" : ""
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                errors[0]
                                  ? _c("error", {
                                      staticClass: "pt-2",
                                      attrs: {
                                        message:
                                          "Al menos un Diagnóstico es requerido.",
                                        variant: "no-border"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        1463047203
                      )
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "div",
        { staticClass: "mt-4" },
        [
          _c("section-title", {
            attrs: { "has-line": "", title: "Recomendación de Intervención" }
          })
        ],
        1
      ),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-md-4 border-right" },
          [
            _c("div", { staticClass: "data-name" }, [
              _vm._v(" ¿Recomienda Intervención? ")
            ]),
            !_vm.isReadOnly
              ? _c("validation-provider", {
                  ref: "appointmentTherapyFlag",
                  attrs: { rules: "required" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-radio", {
                              staticClass: "mt-2 mb-2",
                              attrs: {
                                "custom-error-msg": "Favor contestar Sí o No.",
                                error: errors[0],
                                "is-inline": "",
                                name: "appointmentTherapyFlag",
                                options: _vm.yesNoOptions
                              },
                              model: {
                                value: _vm.model.appointmentTherapyFlag,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "appointmentTherapyFlag",
                                    $$v
                                  )
                                },
                                expression: "model.appointmentTherapyFlag"
                              }
                            })
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    1558841819
                  )
                })
              : _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm._f("boolText")(_vm.model.appointmentTherapyFlag)
                      ) +
                      " "
                  )
                ])
          ],
          1
        ),
        _vm.model.appointmentTherapyFlag && _vm.showIntervationRecommendation
          ? _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c("intervention-recomendation", {
                  attrs: {
                    id: _vm.appointmentId,
                    "catalog-interventions": _vm.catalog.intervations,
                    durations: _vm.catalog.durations,
                    frequencies: _vm.catalog.frequencies,
                    "get-appointment-therpies": _vm.getTherpies,
                    "is-read-only": _vm.isReadOnly,
                    modalities: _vm.catalog.modalities,
                    "show-durations": _vm.showFields.durations,
                    "show-frequency": _vm.showFields.frequencies,
                    "show-intervation": _vm.showFields.intervations,
                    "show-modalities": _vm.showFields.modalities
                  },
                  on: {
                    "on-change-therapies": function($event) {
                      _vm.model.therapies = $event
                    },
                    "on-change-therapy-flag": function($event) {
                      _vm.model.appointmentTherapyFlag = $event
                    }
                  }
                }),
                _vm.showTherapiesError
                  ? _c("error", {
                      attrs: {
                        message:
                          "Debe agregar al menos una Recomendación de Intervención",
                        variant: "no-border mt-1"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }